import React from "react";
import styled from "styled-components";

function notFoundPage() {
	const Container = styled.div`
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
	`;

	return (
		<Container>
			<h1>Aguarde!</h1>
			<h2>Estamos em construção...</h2>
		</Container>
	);
}

export default notFoundPage;
